<template>
  <a-modal
    :title="title"
    :width="modalWidth"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-form class="tenant-form">
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="道路选择">
        <a-tree-select
          :tree-data="treeData"
          v-model="selectId"
          style="width: 100%"
          :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          placeholder="请选择道路"
          allow-clear
          tree-default-expand-all
        ></a-tree-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文件">
        <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
          <a-button type="primary" style="margin-left: 8px" :loading="exportLoading">
            <a-icon type="upload" />选择文件
          </a-button>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { handleImportBlobResponse } from '@/utils/importUtils'

export default {
  name: 'ImportModal',
  props: {
    treeData: {
      type: Array,
      default: function () {
        return []
      }
    },
    exportUrl: {
         type: String
    }
  },
  data () {
    return {
      exportLoading: false,
      fileList: [],
      selectId: '',

      queryUrl: 'zone-metering/zone-metering',
      title: '导入',
      modalWidth: 800,
      visible: false,

      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },

      form: this.$form.createForm(this)
    }
  },
  methods: {
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload (file, fileList) {
      this.fileList = [...this.fileList, file]
      // 限制文件只能上传一个
      this.fileList = this.fileList.slice(-1)
      return false
    },
    changeFile (info) {},
    getErrorFileName () {
      if (this.exportUrl && this.exportUrl.includes('pipe-lines')) {
        return '管线导入失败数据.xlsx'
      }
      if (this.exportUrl && this.exportUrl.includes('pipe-networks')) {
        return '管点导入失败数据.xlsx'
      }
      return '导入失败数据.xlsx'
    },
    saveFile (formData) {
      this.exportLoading = true
      this.axios({
        method: 'post',
        url: this.exportUrl,
        headers: {},
        params: {},
        data: formData,
        responseType: 'blob'
      })
        .then((response) => handleImportBlobResponse(response, { errorFileName: this.getErrorFileName() }))
        .then(({ hasErrorFile, message }) => {
          this.close()
          if (hasErrorFile) {
            this.$message.warning(message)
          } else {
            this.$message.success(message)
          }
          this.$emit('reLoad')
        })
        .catch((error) => {
          this.$message.error(error.message || '导入失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    show () {
            this.exportLoading = false
      this.visible = true
      // this.init()
    },
    handleCancel () {
      this.close()
    },
    close () {
      this.visible = false
      this.fileList = []
      this.selectId = ''
      //   this.disableSubmit = false
    },
    handleOk () {
      if (!this.selectId) {
           this.$message.error('请选择一个分区')
      } else if (this.fileList.length) {
        const formData = new FormData()
        formData.append('file', this.fileList[0])
        formData.append('zone_id', this.selectId)
        this.saveFile(formData)
      } else {
        this.$message.error('请选择上传文件')
      }
    }
  }
}
</script>

<style scoped>
</style>
